module.exports = __webpack_public_path__ + "img/No_name.93e395fe.jpg";